


































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { Option } from '@/models'

@Component({
  components: {
    ListItem
  }
})
export default class OptionTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly option!: Option

  @Prop({ type: Number, required: true })
  readonly optionGroupId!: number

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number
}
